import { render, staticRenderFns } from "./MedecinDetailParcourscliniquecreate.vue?vue&type=template&id=6c1e4e61&"
import script from "./MedecinDetailParcourscliniquecreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailParcourscliniquecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports